import CustomDataGrid, {DataGridRef} from "@/components/data-grid/CustomDataGrid";
import CustomRowButton from "@/components/data-grid/CustomRowButton";
import Dialog from "@/components/dialog";
import DepartmentService from "@/services/hr/DepartmentService";
import { HREndpoints } from "@/services/hr/endpoints";
import WebURL from "@/urls";
import SnackbarUtil from "@/utils/SnackbarUtil";
import { Add, Edit, DeleteForever } from "@mui/icons-material";
import { Backdrop, Breadcrumbs, CircularProgress, Grid, Stack } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import React, {useRef, useState} from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {ReactComponent as IconEdit} from '@/assets/icons/IconEdit.svg';
import {ReactComponent as IconDeletes} from '@/assets/icons/IconDeletes.svg';
import DepartmentView from "./components/DepartmentView";
import CustomBreadcrumbs from "@/components/breadcrumbs/CustomBreadcrumbs";

const DepartmentDataGrid: React.FC = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const dataGridRef = useRef<DataGridRef>()
  const departmentViewRef = useRef<any>({})
  const columns: GridColDef[] = [
    {field: 'name', headerName: t("common.Department Name"), flex: 0.4 },
    {field: 'code', headerName: t("common.Department Code"), flex: 0.4 },
    {
      field: 'actions', flex: 0.2, headerName: t("common.action"), headerAlign: 'left', align: 'left',
      sortable: false,
      renderCell: (e) => {
        return (
          <Stack direction={"row"}>
            <Grid sx={{marginLeft: "-5px"}}>
              <CustomRowButton
                insideSvgIcon={IconEdit}
                actionName={t("common.edit")}
                buttonProps={{
                  key: "edit",
                  onClick: () => {
                    departmentViewRef?.current?.showDetail(e.id)
                    // navigate(WebURL.HR_DEPARTMENT_VIEW, {state: {id: e.id}});
                  }
                }}
              />
            </Grid>
            <Grid>
              <CustomRowButton
                insideSvgIcon={IconDeletes}
                actionName={t("common.delete")}
                buttonProps={{
                  key: "delete",
                  onClick: () => (
                    Dialog.confirm({
                      title: t("hr.department.Delete Department?"),
                      content: t("hr.department.Delete Confirm"),
                      onConfirm: () => {
                        DepartmentService.destroy((e.id).toString()).then(
                          (result) => {
                            SnackbarUtil.success(t('common.success'));
                            dataGridRef.current?.refresh();
                          });
                      }
                    })
                  )
                }}
              />
            </Grid>
          </Stack>
        )
      }
    }
  ]

  const reloadTable = () => {
    dataGridRef.current?.refresh();
  }

  return (
    <>
      <CustomBreadcrumbs record={[{label: t("common.Department")}]}/>
      <CustomDataGrid
        ref={dataGridRef}
        uri={HREndpoints.HR_DEPARTMENT_URI}
        columns={columns}
        checkboxSelection={false}
        toolbar={{
          title: t("common.Department"),
          searchTips: t("common.Search by Department Name, Department Code"),
          breadcrumbs: [
            {breadcrumbName: t("common.Department"), path: WebURL.HR_DEPARTMENT }
          ],
          actions: [{
            key: 'add', iconFont:'icon-ic_add', helpTxt: t("common.add"), callback: async () => {
              departmentViewRef?.current?.showDetail()
              // navigate(WebURL.HR_DEPARTMENT_NEW);
            }
          }]
        }}
      />
      <DepartmentView ref={departmentViewRef} reloadTable={reloadTable}></DepartmentView>
    </>
  )
}

export default DepartmentDataGrid;
